import React, { useState } from 'react';
import { Dialog } from '@tencent/spaui';
import { isLeadsRole } from '../../utils/routes';

const Util = {
  getCacheKey() {
    const userId = window.pageProps.operationUserId;
    return `_cache_new_feature_${userId}`;
  },
  getCacheValue() {
    const cacheKey = this.getCacheKey();
    return localStorage.getItem(cacheKey);
  },
  confirm() {
    const cacheKey = this.getCacheKey();
    localStorage.setItem(cacheKey, 'true');
  },
  getDefaultShow() {
    return isLeadsRole('免登录') && this.getCacheValue() !== 'true';
  },
};

const FreeLoginDialog = () => {
  const [show, setShow] = useState(Util.getDefaultShow());

  const handleSubmit = () => {
    setShow(false);
    Util.confirm();
  };

  return (
    <Dialog
      type="normal"
      submitLabel="我知道了"
      className="free-login-tips"
      show={show}
      title={null}
      closeButton={null}
      cancelButton={null}
      style={{ width: 600 }}
      onSubmit={handleSubmit}
      footerStyle={{ textAlign: 'center' }}
    >
      <p style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>腾讯内部员工登录须知</p>
      <br />
      <p>通过adhome免登录广告主账户，仅限于经广告主申请为其排查、处理账户问题。</p>
      <br />
      <p>若经广告主委托为其处理账户内用户数据，则应由广告主自行或通过线索通主动回传用户数据后再进行处理，不得直接登录广告主账户。</p>
    </Dialog>
  );
};

export default FreeLoginDialog;
